import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Params, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../../retailer.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-editcomment',
  templateUrl: './editcomment.component.html',
  styleUrls: ['./editcomment.component.scss']
})
export class EditcommentComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  editCommentForm: FormGroup;
  retailerId: any;
  commentId: any;
  commentDetails: any;
  visitTypes: any= [];
  storeName: any;
  retailerName: any;
  accountNumber: any;
  newDate = new Date();
  constructor(private cdref: ChangeDetectorRef, 
                private fb: FormBuilder, 
              public dialog: MatDialog, 
              private router: Router,
              private activeRoute:ActivatedRoute, 
              private retailerService: RetailerService) { 
    super();
    this.uiConfigValuesService.getUIConfigValues('VisitTypes').subscribe(res=> {
      this.visitTypes = res['data'];
    })
    this.retailerId = this.activeRoute.snapshot.params.retailerId;
    this.commentId = this.activeRoute.snapshot.params.commentId;  
    this.retailerService.getSelectedRetailer(this.retailerId).subscribe(res => {
      if (res['httpcode'] == 200) {
        this.storeName = res.data.retailerDetails.dbaName;
        this.retailerName = res.data?.retailerDetails?.businessName;
        this.accountNumber = res.data?.retailerAccounts?.retailerAccountNum;
      }
    })

  }

  ngOnInit(): void {
    super.ngOnInit()
    this.editCommentForm = this.fb.group({
      callDuration: ['', [Validators.required]],
      comment: ['', [Validators.required]],
      spokeWith: ['', [Validators.required]],
      visitType: ['', [Validators.required]],
      visitedDate: ['', [Validators.required]],
      visitedTime: ['', [Validators.required]]
    })
    this.retailerService.getComment(this.commentId).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        this.commentDetails = resData.data;
        this.editCommentForm.get('callDuration').setValue(this.commentDetails.callDuration);
        this.editCommentForm.get('comment').setValue(this.commentDetails.comment);
        this.editCommentForm.get('spokeWith').setValue(this.commentDetails.spokeWith);
        this.editCommentForm.get('visitType').setValue(this.commentDetails.visitType);
        this.editCommentForm.get('visitedDate').setValue(this.commentDetails.visitedDate);
        this.editCommentForm.get('visitedTime').setValue(this.commentDetails.visitedTime);
      }
    }) 
  }

  get f() {
    return this.editCommentForm.controls;
  }

  onSubmit() {
   
    if (this.editCommentForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.editCommentForm)
        }else{
          this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}`])
        }
      });

    }
    //
  }

  setSubmitParameters(editCommentForm: FormGroup) {

    let httpParams: Params = {
      callDuration: editCommentForm.get('callDuration').value,
      comment: editCommentForm.get('comment').value,
      spokeWith: editCommentForm.get('spokeWith').value,
      visitType: editCommentForm.get('visitType').value,
      visitedDate: editCommentForm.get('visitedDate').value,
      visitedTime: editCommentForm.get('visitedTime').value,
      retailerId: this.retailerId,
      commentId: this.commentId,
    }
    //

    this.retailerService.editComment(httpParams).subscribe(res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_110") || res.responseStatus == 'Success'){
            this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}`])
            this.toastrService.success('Updated Comment successfully', 'Success', {
              timeOut: 3000,
            });        
        }
      }
    });
  }


  onCancel() {
    for (const name in this.editCommentForm.controls) {
      if (this.editCommentForm.controls[name].invalid) {
       
      } else {
       
      }
    }

    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        //this.editCommentForm.reset()
        //window.location.reload()
        this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}`])
      }
    });
  }
  checkSubmitDisplayed(){
    return !(this.editCommentForm.valid && !this.editCommentForm.pristine)
  }
}
